



import logo_dimos_voulas2 from '../assets/logo_dimos_voulas2.jpg';
import kathara_mazi from '../assets/kathara_mazi.png';
import useAuth from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';







function ModalHeader(props) {

    const navigate = useNavigate();

    const { isAuthenticated, logout } = useAuth();
    return (
        <div className="flex content-center self-center justify-between w-full pt-3 pb-3  rounded-b-[0%]  " >

            <div className='flex justify-center pl-10'>
                <a href="/">
                    <img
                        src={logo_dimos_voulas2}
                        width={200}

                        alt="Float UI logo"
                    />
                </a>
                
            </div>
            <div className="flex flex-col items-center pr-16" >

                <h1 className="pt-0 text-3xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-app_green to-app_blue">
                    {props.title} 
                </h1>
                
                {/* if props.subtitle */}
                {/* <span className="text-app_green_light text-sm p-0 m-0">v2.6.3</span> */}
                
                {props.subtitle && <h2 className="text-xl font-semibold leading-relaxed text-transparent bg-clip-text bg-gradient-to-r from-app_green to-app_blue ">
                    {props.subtitle}
                </h2>
                }

                {/* <div className="flex justify-center items-center mb-2">
                <button
                    onClick={() => {
                        logout()
                    }}
                    className="flex justify-center w-auto text-white bg-gradient-to-r from-app_green  to-app_green_light hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-semibold rounded-full text-2xl px-16 py-3 text-center">
                    Αποσύνδεση
                </button>

                </div> */}


            </div>
            <div className='flex justify-center mr-10 '>
                <div className=''>
                    <img
                        src={kathara_mazi}
                        width={128}

                        alt="Float UI logo"
                    />
                </div>
                
            </div>
            
        </div>
    );
}

export default ModalHeader;
